module.exports = __webpack_public_path__ + "static/media/bocadillos.b8629cb7.jpg";